<template>
    <div class="pagination">
        <button :disabled="!canMovePrevGroup" @click="goToPage(startPage - 1)"><</button>

        <button
            v-for="page in pagesToShow"
            :key="page"
            :class="{ active: currentPage === page }"
            @click="goToPage(page)"
        >
            {{ page }}
        </button>

        <button :disabled="!canMoveNextGroup" @click="goToPage(endPage + 1)">></button>
    </div>
</template>

<script>
export default {
    name: "Pagination",
    props: {
        totalItems: {
            type: Number,
            required: true,
        },
        pageSize: {
            type: Number,
            default: 10,
        },
        modelValue: {
            type: Number,
            default: 1,
        },
        pageGroupSize: {
            type: Number,
            default: 10
        },
    },
    emits: ["update:modelValue", "page-change"],
    computed: {
        totalPages() {
            return Math.ceil(this.totalItems / this.pageSize) || 1;
        },
        currentPage: {
            get() {
                return this.modelValue;
            },
            set(val) {
                if (val < 1) val = 1;
                if (val > this.totalPages) val = this.totalPages;
                this.$emit("update:modelValue", val);
                this.$emit("page-change", val);
            },
        },
        // 현재 페이지 그룹 시작 번호
        startPage() {
            return Math.floor((this.currentPage - 1) / this.pageGroupSize) * this.pageGroupSize + 1;
        },
        // 현재 페이지 그룹 끝 번호 (최대 totalPages)
        endPage() {
            let end = this.startPage + this.pageGroupSize - 1;
            return end > this.totalPages ? this.totalPages : end;
        },
        // 보여줄 페이지 배열 (1~10, 11~20 등)
        pagesToShow() {
            const pages = [];
            for (let i = this.startPage; i <= this.endPage; i++) {
                pages.push(i);
            }
            return pages;
        },
        // 이전 그룹으로 이동 가능 여부
        canMovePrevGroup() {
            return this.startPage > 1;
        },
        // 다음 그룹으로 이동 가능 여부
        canMoveNextGroup() {
            return this.endPage < this.totalPages;
        },
    },
    methods: {
        goToPage(page) {
            this.currentPage = page;
        },
    },
};
</script>

<style scoped>
.pagination button.active {
    background-color: #1890ff;
    color: white;
}
.pagination button:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}
</style>
